import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import * as crypto from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class LocalTokenStoreService {

  private tokenSecret = environment.tokenAESSecret;
  private authenticatorTokenSecret = environment.authenticatorTokenAESSecret;

  constructor() { }

  // Encryption before storing into local storage
  encryptToken(JWTToken: string) {
    return crypto.AES.encrypt(JWTToken, this.tokenSecret).toString();
  }

  decryptToken(encryptedToken: string) {
    const bytes = crypto.AES.decrypt(encryptedToken, this.tokenSecret);
    return  bytes.toString(crypto.enc.Utf8);
  }

  encryptAuthenticatorToken(authenticatorToken) {
    const token = JSON.stringify(authenticatorToken);
    return crypto.AES.encrypt(token, this.authenticatorTokenSecret).toString();
  }

  decryptAuthenticatorToken(encryptedToken: string) {
    const bytes = crypto.AES.decrypt(encryptedToken, this.authenticatorTokenSecret);
    let tokenObj: any;
    try {
      tokenObj = JSON.parse(bytes.toString(crypto.enc.Utf8));
      return tokenObj;
    } catch {}
    return null;
  }

  isValidHash(encryptedToken: string) {
    return true;
  }

  parseJWTToken(token) {
    return new Promise((resolve, reject) => {
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        resolve(JSON.parse(jsonPayload));
      } catch {
        reject('Invalid token');
      }
    });
  }
}
